import { API_URL, apiErrorResponse } from '@/shared/api/constants'
import apiResponseStrategy from '@/shared/api/client-api/api-response.strategy'
import { ApiResponse } from '@/shared/api/types'

function extractLegacyAuthErrorMessage(json: any): string | null {
  if (json?.status !== 'failure') {
    return null
  }

  if (typeof json?.data === 'string' && json.data.trim()) {
    return json.data
  }

  if (typeof json?.message === 'string' && json.message.trim()) {
    return json.message
  }

  if (typeof json?.data?.message === 'string' && json.data.message.trim()) {
    return json.data.message
  }

  return null
}

export async function legacyAuthRequest<T>(input: string, init?: RequestInit): Promise<ApiResponse<T>> {
  try {
    if (!API_URL) {
      throw new Error('Provide API_URL')
    }

    const res = await fetch(`${API_URL}/${input}`, {
      cache: 'no-cache',
      ...init,
    })

    const contentType = res.headers.get('content-type')
    if (!contentType || !contentType.includes('application/json')) {
      return apiErrorResponse({
        status: res.status,
        message: `Ошибка сервера: ${res.status} ${res.statusText}`,
      })
    }

    const json = await res.json()
    const legacyErrorMessage = extractLegacyAuthErrorMessage(json)

    if (legacyErrorMessage) {
      return apiErrorResponse({
        status: json?.status || res.status,
        message: legacyErrorMessage,
        error: new Error(legacyErrorMessage),
      })
    }

    const response = await apiResponseStrategy<T>({ response: res, json })
    if (response) {
      return response
    }

    return apiErrorResponse({
      status: res.status,
      message: res.statusText || 'An unknown error occurred',
    })
  } catch (error: any) {
    return apiErrorResponse({
      error,
    })
  }
}
